module.exports = __webpack_public_path__ + "img/p-two-step-12.01a68c25.png";